import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import axios from 'axios';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import {Message, MGSiteButton} from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetLoginCardComponent';

var styles = AppSettings.styles;

class LoginCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            qrcode: null,
            error: false,
            errorMessage: "",
            pin: ""
        }

    }

    getQrCode(){
        this.setState({
            showLoading: true,
            error: false,
            errorMessage: "",
            pin:""
        });

        var url = AppSettings['env'].urlUserBoxGetTokenQrCode;
        
        var params = {
            data: document.getElementById('password').value
        }
        this.refs.password.value = "";
        axios.post(url, params)
            .then(({data, status, statusText}) => {
                document.getElementById('password').value = "";
                if (data.errors.length == 0) {
                    var qr = qrCode.qrcode(10, 'M');
                    qr.addData(data.encrypted);
                    qr.make();

                    this.setState({                       
                        showLoading: false,
                        qrcode: qr.createImgTag(3),
                        error: false,
                        pin: data.pin,
                        errorMessage: ""

                    }); 

                } else {
                    this.setState({
                        showLoading: false,
                        pin:"",
                        error: true,
                        errorMessage: data.errors[0].userMessage
                    });
                }
            })

            .catch(({data, status, statusText}) => {
                this.setState({
                    showLoading: false,
                    error: true,
                    pin:"",
                    errorMessage: "Errore generico"
                });
            });
            

    }
    renderQrCode(){
        if(this.state.qrcode){
            return (
                <div>
                    <br />
                    <div dangerouslySetInnerHTML={{__html: this.state.qrcode}} ></div>
                    <br />
                    <p>Il tuo pin: <strong>{this.state.pin}</strong></p>
                </div>
            )
        }
        else{
            return "";
        }        
    }

    render() {
        var coupon = this.props.data
        var baseCssClass = "mg-login-card";

        return (
            <div className="mg-user-widget">
                <Card containerStyle={styles.mgCardStyle}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title="Biglietto da visita"
                                subtitle=""
                                actAsExpander={true}
                                showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                        <p>Inserire la password per generare il QRCODE:</p>
                        
                         <TextField
                            id="password"
                            ref="password"
                                hintText="Inserire la password"
                                floatingLabelText="Password"
                                type="password"
                                />

                        <MGSiteButton
                            title="Genera"
                            label="Genera"
                            disabled={false}
                            primary={true}
                            isButton={true}
                            fullWidth={true}
                            actionFunc={this.getQrCode}                             
                        />                    
                        {this.state.showLoading?
                            <CircularProgress style={styles.loadingIcon}/>
                            : this.renderQrCode()
                        }

                        {this.state.error?
                            <Message type="error" >{this.state.errorMessage}</Message>
                        : null}
                                                
                    </CardText>
                </Card>
            </div>

        );
    }
}

LoginCard.displayName = componentName;

// PropTypes validation
LoginCard.propTypes = {
};

// default props
LoginCard.defaultProps = {
};

export default LoginCard;